<template>
  <v-container class="my-4">
    <v-row class="text-center" justify="center">
      <v-col cols="12">
        <p class="text-body-1">
          {{ $t('L_to_change_your_beneficiaries_first') }}
          <a
            href="javascript:void(0)"
            id="ca_doc_multi-purpose"
            @click="openDocument(formLinks['multiPurposeForm'], $t('L_multi_purpose_form'))"
            class="blueLinkPointer"
          >
            {{ $t('L_to_change_your_beneficiaries_multi_purpose_change_form') }}
          </a>
          {{ $t('L_to_change_your_beneficiaries_last') }}
        </p>
      </v-col>
      <EmbeddedViewer
        :title="document.title"
        :loading="document.loading"
        content-type="application/pdf"
        :content-url="document.content"
        @close="document.content = undefined"
      />
    </v-row>
    <v-row justify="center">
      <v-col cols="12" class="text-center">
        <p class="text-body-1">
          {{ $t('L_policy_beneficiaries_company_CA') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_address_ca') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_include_note') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import EmbeddedViewer from '@/components/EmbeddedViewer.vue';
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';

const phone = [
  { href: '18002654804', num: '(800) 265-4804' },
  { href: '18003877876', num: '(800) 387-7876' },
];

const componentOptions: ComponentOptions = {
  name: 'CABeneficiaryCard',
  components: {
    EmbeddedViewer,
  },
  props: {
    isQuebec: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    document: {
      title: '',
      content: '' as string | undefined,
      loading: false,
    },
  }),
  computed: {
    ...mapState(useGlobalStore, ['containsFeature', 'features']),
    ...mapState(usePolicyStore, {
      beneficiaries: 'beneficiaries',
      isPending: 'isPending',
    }),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    displayBeneficiaries() {
      return (
        this.containsFeature(FEATURE_FLAGS.BENEFICIARIES) &&
        this.beneficiaries &&
        this.beneficiaries?.length > 0
      );
    },
    phone() {
      return this.isQuebec ? phone[0] : phone[1];
    },
    formLinks() {
      if (this.locale === 'en_CA') {
        return { ...window.appConfig.policyDocumentForms.en_CA };
      }
      return { ...window.appConfig.policyDocumentForms.fr_CA };
    },
  },
  methods: {
    openDocument(content: string, title: string) {
      this.document.title = title;
      this.document.content = `${window.appConfig.content_stack}${content}`;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.blueLinkPointer {
  text-decoration: none;
  color: rgb(12, 109, 202);
  font-weight: 600;
  cursor: pointer;
}
</style>
